import React, { FC } from 'react';
import { SrWidget } from './SrWidget';

export interface SrWidgetMatchCommentaryProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
}

export const SrWidgetMatchCommentary: FC<SrWidgetMatchCommentaryProps> = ({ matchId, ...props }) => {
    const widgetProps = {
        matchId: matchId,
        disableWidgetHeader: true,
        commentsExpanded: true,
        showExpandSwitch: false,
        goalScorers: true,
        showPhrases: true
    };
    return <SrWidget widgetName="match.commentary" widgetProps={widgetProps} {...props} />;
};
